import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ArrowLeft, Save } from 'lucide-react';
import PageHeader from '../../components/common/PageHeader';

interface ProductFormValues {
  productName: string;
  upc: string;
  serviceType: string;
  processType: string;
  productType: string;
  methodOfDelivery: string;
  description: string;
  price: number;
  maxEtaDays: number;
}

export default function ProductCreatePage() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ProductFormValues>();

  const onSubmit = (_values: ProductFormValues) => {
    // Product creation endpoint is not currently available in the API
    // This form is a placeholder for when the endpoint is added
    alert('Product creation API endpoint not yet available. Please create products via the backend.');
  };

  return (
    <div>
      <PageHeader
        title="Create Product"
        actions={
          <button onClick={() => navigate('/products')} className="btn-secondary gap-1">
            <ArrowLeft className="h-4 w-4" />
            Back
          </button>
        }
      />

      <form onSubmit={handleSubmit(onSubmit)} className="max-w-2xl space-y-4 lg:space-y-6">
        <div className="card p-4 lg:p-6">
          <h2 className="text-base lg:text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3 lg:mb-4">Product Information</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="sm:col-span-2">
              <label className="label">Product Name *</label>
              <input
                type="text"
                className="input"
                {...register('productName', { required: 'Required' })}
              />
              {errors.productName && (
                <p className="text-sm text-red-500 mt-1">{errors.productName.message}</p>
              )}
            </div>
            <div>
              <label className="label">UPC *</label>
              <input
                type="text"
                className="input"
                {...register('upc', { required: 'Required' })}
              />
              {errors.upc && <p className="text-sm text-red-500 mt-1">{errors.upc.message}</p>}
            </div>
            <div>
              <label className="label">Service Type</label>
              <input type="text" className="input" {...register('serviceType')} />
            </div>
            <div>
              <label className="label">Process Type</label>
              <input type="text" className="input" {...register('processType')} />
            </div>
            <div>
              <label className="label">Product Type</label>
              <input type="text" className="input" {...register('productType')} />
            </div>
            <div>
              <label className="label">Method of Delivery</label>
              <input type="text" className="input" {...register('methodOfDelivery')} />
            </div>
            <div>
              <label className="label">Description</label>
              <input type="text" className="input" {...register('description')} />
            </div>
            <div>
              <label className="label">Price</label>
              <input type="number" step="0.01" className="input" {...register('price', { valueAsNumber: true })} />
            </div>
            <div>
              <label className="label">Max ETA (days)</label>
              <input type="number" className="input" {...register('maxEtaDays', { valueAsNumber: true })} />
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <button type="button" onClick={() => navigate('/products')} className="btn-secondary">
            Cancel
          </button>
          <button type="submit" className="btn-primary gap-1">
            <Save className="h-4 w-4" />
            Create Product
          </button>
        </div>
      </form>
    </div>
  );
}
